var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import axios from "axios";
import { GalaxyApi } from "@/api";
import { withPrefix } from "@/utils/redirect";
import { rethrowSimple } from "@/utils/simple-error";
export function fetchDatasetDetails(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().GET("/api/datasets/{dataset_id}", {
            params: {
                path: {
                    dataset_id: params.id,
                },
                query: { view: "detailed" },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function undeleteDataset(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().PUT("/api/datasets/{dataset_id}", {
            params: {
                path: { dataset_id: datasetId },
            },
            body: {
                deleted: false,
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function purgeDataset(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().DELETE("/api/datasets/{dataset_id}", {
            params: {
                path: { dataset_id: datasetId },
                query: { purge: true },
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function copyDataset(datasetId, historyId, type = "dataset", source = "hda") {
    return __awaiter(this, void 0, void 0, function* () {
        const { data, error } = yield GalaxyApi().POST("/api/histories/{history_id}/contents/{type}s", {
            params: {
                path: { history_id: historyId, type },
            },
            body: {
                source,
                content: datasetId,
                // TODO: Investigate. These should be optional, but the API requires explicit null values?
                type,
                copy_elements: null,
                hide_source_items: null,
                instance_type: null,
            },
        });
        if (error) {
            rethrowSimple(error);
        }
        return data;
    });
}
export function getCompositeDatasetLink(historyDatasetId, path) {
    return withPrefix(`/api/datasets/${historyDatasetId}/display?filename=${path}`);
}
export function fetchDatasetAttributes(datasetId) {
    return __awaiter(this, void 0, void 0, function* () {
        const { data } = yield axios.get(withPrefix(`/dataset/get_edit?dataset_id=${datasetId}`));
        return data;
    });
}
